import { ITranslations } from 'types/common';
import { ProductsTableTransFields } from './types';
import en from 'translations/en/productsTable.json';
import pl from 'translations/pl/productsTable.json';
import sl from 'translations/sl/productsTable.json';

export const productsTableTranslations: ITranslations<ProductsTableTransFields> = {
  name: 'productsTable',
  en,
  pl,
  sl,
};
